import { render, staticRenderFns } from "./system_site.vue?vue&type=template&id=404f47a4&scoped=true&"
import script from "./system_site.vue?vue&type=script&lang=js&"
export * from "./system_site.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404f47a4",
  null
  
)

export default component.exports